<template>
    <div class="card">
        <h1>Схожі товари ({{ total }})</h1>

        <div class="mb-2" v-if="!loading">
            <Button label="Пропустити пару" @click="scipPair()" severity="secondary" />
        </div>

        <template v-if="loading">Завантаження..</template>

        <div class="container wrapper" v-else>
            <Card v-for="(product, i) in data" :key="i">
                <template #header>
                    <img v-if="product.media" alt="user header" :src="getProductPhoto(product.media)" />
                    <img v-else alt="user header" src="/img/no_image.png" />
                </template>
                <template #title>
                    <p style="font-size: 15px;" v-html="getName(i)"></p>
                </template>
                <template #subtitle>{{ product.remote_id }}</template>
                <template #content>
                    <p class="m-0">
                        Артикул: <b>{{ product.article }}</b>
                    </p>
                    <p class="m-0">
                        Бренд: <b>{{ product.brand ? product.brand.title : '' }}</b>
                    </p>
                    <p class="m-0">
                        ID в системі: {{ product.id }}
                    </p>
                    <p class="m-0">
                        Ціна: {{ product.price }} {{ product.currency }}
                    </p>
                    <p class="m-0">
                        Медіа: {{ product.media_count }}
                    </p>
                    <p class="m-0">
                        Файли: {{ product.products_files_count }}
                    </p>
                    <p class="m-0">
                        Характеристики: {{ product.characteristics_count }}
                    </p>
                    <p class="m-0">
                        Аксесуари: {{ product.accessories_count }}
                    </p>
                </template>
                <template #footer>
                    <div class="flex">
                        <Button label="Залишити цей товар" @click="makeMain(product.id)" severity="secondary" class="w-full mr-1" />
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import moment from "moment";

export default {

    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Button,
        Card,
        Dropdown,
        Toast,
    },
    layout: AppLayout,

    data() {
        return {
            moment: moment,
            data: [],
            total: 0,
            loading: true,
            scipped: [],
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        makeMain(id) {
            this.loading = true
            axios.post(this.route('api.catalog.product.duplicates.main'), {id: id, data: this.data}).then(result => {
                this.loading = false

                this.getData()
            });
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.catalog.product.duplicates.get'), {scipped: this.scipped}).then(result => {
                this.data = result.data.products;
                this.total = result.data.total;
                this.loading = false
            });
        },
        getProductPhoto(media) {
            if (media.photos) {
                return media.photos.split('; \n').slice(1);
            }

            return '/img/no_image.png';
        },
        splitLine(line) {
            if (line) {
                return line.split(' ');
            }

            return []
        },
        isDifferent(word, index) {
            let lines = []
            this.data.forEach((value, index) => {
                lines.push(value.name)
            });

          const allWordsAtIndex = lines.map(line => this.splitLine(line)[index]);
          return new Set(allWordsAtIndex).size > 1;
        },
        getName(i) {
            let name = ''
            this.splitLine(this.data[i].name).forEach((word, index) => {
                if (this.isDifferent(word, index)) {
                    name += ' <span style="text-decoration: underline; background: greenyellow;">' + word + '</span> '
                } else {
                    name += ' ' + word
                }
            });

            return name
        },
        scipPair() {
            this.data.forEach((value, index) => {
                this.scipped.push(value.remote_id)
            });

            this.getData()
        },
    }
};
</script>

<style scoped>
    .wrapper {
        display: grid;
        gap: 15px;
        grid-template-columns: 20rem 20rem 20rem;
    }
</style>
